<template>
  <div class="login-container">
    <div class="login-box">
      <h2>系统登录</h2>
      <div class="input-group">
        <input type="text" v-model="username" placeholder="用户名" @keyup.enter="handleLogin">
        <input type="password" v-model="password" placeholder="密码" @keyup.enter="handleLogin">
        <button @click="handleLogin">登录</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminLogin'
}
</script>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { login } from '@/api/user'
import { useUserStore } from '@/store/user'
import { useNotify } from '@/utils/notify'

const router = useRouter()
const userStore = useUserStore()
const username = ref('')
const password = ref('')

const handleLogin = async () => {
  // 表单验证
  if (!username.value || !password.value) {
    useNotify.Warning('请输入用户名和密码')
    return
  }

  try {
    const res = await login({
      username: username.value,
      password: password.value
    })
    
    if (res.code === 200) {
      // 保存token
      userStore.setToken(res.data)
      // 保存用户信息
      userStore.setUserInfo(res.userInfo)
      // 显示成功消息
      useNotify.Success('登录成功')
      // 跳转到首页
      router.push('/')
    } else {
      useNotify.Error(res.msg || '登录失败')
    }
  } catch (error) {
    useNotify.Error(error.message || '登录失败')
  }
}
</script>

<style scoped>
.login-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000000;
  padding: 20px;
}

h2 {
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
  font-size: 24px;
  color: #ffa31a;
}

.login-box {
  width: 400px;
  max-width: 100%;
  padding: 30px;
  background: #1b1b1b;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.5);
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

input {
  width: 100%;
  padding: 12px;
  background: #2a2a2a;
  border: 1px solid #3a3a3a;
  border-radius: 4px;
  font-size: 16px;
  color: white;
  transition: all 0.3s;
}

input:focus {
  outline: none;
  border-color: #ffa31a;
  box-shadow: 0 0 5px rgba(255, 163, 26, 0.3);
}

input::placeholder {
  color: #666;
}

button {
  width: 100%;
  padding: 12px;
  background: #ffa31a;
  color: #000000;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  transition: background 0.3s;
}

button:hover {
  background: #ff9000;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .login-box {
    width: 100%;
    padding: 20px;
  }

  h2 {
    font-size: 20px;
    margin-bottom: 15px;
  }

  input {
    padding: 10px;
    font-size: 14px;
  }

  button {
    padding: 10px;
    font-size: 14px;
  }

  .input-group {
    gap: 15px;
  }
}

/* 超小屏幕适配 */
@media screen and (max-width: 320px) {
  .login-box {
    padding: 15px;
  }

  h2 {
    font-size: 18px;
    margin-bottom: 10px;
  }
}
</style>
